import { AGE_ID, AGE_YEAR_ID } from '../../../const';

export default [
  {
    id: '346dbfab-03fa-4a3a-ab18-b461d0d56dc7',
    questionOrder: 1,
    readableId: AGE_ID,
    readableIdYear: AGE_YEAR_ID,
    analyticsId: 'selected_age',
    type: 'age',
    title: 'What age is the player?',

    inputTitle: 'Enter your age (between 5 & 99)',

    helpText: 'Type the players’ age.',
    config: {
      min: 5,
      max: 99,
      step: 1,
      defaultValue: 5,
      labelMin: '5',
      labelMax: '99+',
    },
    yearGroup: [
      {
        age: 5,
        options: ['Reception', 'Year 1','Other year group'],
      },
      {
        age: 6,
        options: ['Year 1', 'Year 2','Other year group'],
      },
      {
        age: 7,
        options: ['Year 2', 'Year 3','Other year group'],
      },
      {
        age: 8,
        options: ['Year 3', 'Year 4','Other year group'],
      },
      {
        age: 9,
        options: ['Year 4', 'Year 5','Other year group'],
      },
      {
        age: 10,
        options: ['Year 5', 'Year 6','Other year group'],
      },
      {
        age: 11,
        options: ['Year 6', 'Year 7','Other year group'],
      },
      {
        age: 12,
        options: ['Year 7', 'Year 8','Other year group'],
      },
      {
        age: 13,
        options: ['Year 8', 'Year 9','Other year group'],
      },
      {
        age: 14,
        options: ['Year 9', 'Year 10','Other year group'],
      },
      {
        age: 15,
        options: ['Year 10', 'Year 11','Other year group'],
      },
      {
        age: 16,
        options: ['Year 11 / 16 years old post August 31', 'Year 12 / 16 years old pre August 31','Other year group'],
      },
      {
        age: 17,
        options: ['Year 12 / 17 years old post August 31', 'Year 13 / 17 years old pre August 31','Other year group'],
      },
      {
        age: 18,
        options: ['Year 13 / 18 years old post August 31', '18 years pre August 31','Other year group'],
      },
    ],
    ageRanges: [
      {
        min: 5,
        max: 17,
        nextQuestionId: 'd9572be5-72f2-42af-87ea-a3298c6eacd7',
      },
      {
        min: 18,
        max: 99,
        nextQuestionId: 'd43569c8-1a01-4c53-9575-128698905fbc',
      },
    ],
  },
];
